import { useIsActionDisabledForWorkspace } from './useIsActionDisabledForWorkspace.ts';

export const useShouldShowDSPWarningForWorkspaceRole = (rolePermissions: string[]): boolean => {
	const hasPublicLinksPermission = rolePermissions.includes('MANAGE_PUBLIC_LINKS');
	const hasAnonymousAccessPermission = rolePermissions.includes('NONLICENSED_USER_MANAGEMENT');

	const isPublicLinksActionDisabled = useIsActionDisabledForWorkspace({
		action: 'PUBLIC_LINKS',
		skip: !hasPublicLinksPermission,
	});
	const isAnonymousAccessActionDisabled = useIsActionDisabledForWorkspace({
		action: 'ANONYMOUS_ACCESS',
		skip: !hasAnonymousAccessPermission,
	});

	return (
		(isPublicLinksActionDisabled && hasPublicLinksPermission) ||
		(isAnonymousAccessActionDisabled && hasAnonymousAccessPermission)
	);
};
